import { gql } from 'src/generated/gql';

export const GET_CHART_PROPERTIES = gql(`
  query TaskChartProperties($patientId: ID!, $taskId: ID!) {
    interactionChartProperties(
      patientId: $patientId
      interactionReferenceId: $taskId
      patientSnapshotTime: null
    ) {
      propertyName
      value
    }
  }
`);
